import { Configuration, LogLevel } from '@azure/msal-browser';

// PlanePM Azure AD App Registration - read from environment variables
const clientId = import.meta.env.VITE_CLIENT_ID || 'deda5171-b87b-4857-8738-a4d2e5ca59cb';
const tenantId = import.meta.env.VITE_TENANT_ID || 'ca2871eb-0112-4e04-81b2-c01607fec40c';
const dataverseUrl = import.meta.env.VITE_DATAVERSE_URL || 'https://org1ac9565a.crm.dynamics.com';

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
          case LogLevel.Info:
            console.info(message);
            break;
          case LogLevel.Verbose:
            console.debug(message);
            break;
        }
      },
      logLevel: LogLevel.Warning,
    },
  },
};

// Scopes for authentication
export const loginRequest = {
  scopes: ['User.Read', 'openid', 'profile', 'offline_access'],
};

// Scopes for Microsoft Graph API
export const graphScopes = {
  scopes: ['User.Read', 'Files.ReadWrite.All', 'Sites.ReadWrite.All'],
};

// Scopes for Dataverse API
export const dataverseScopes = {
  scopes: [`${dataverseUrl}/.default`],
};

// Graph API endpoint
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
  graphPhotoEndpoint: 'https://graph.microsoft.com/v1.0/me/photo/$value',
};

// Dataverse API endpoint
export const dataverseConfig = {
  baseUrl: `${dataverseUrl}/api/data/v9.2`,
};
